import { Component } from 'react';
import { Error } from 'status';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? <Error isStoreButton={false} /> : this.props.children;
  }
}
